import { render, staticRenderFns } from "./moveEscPage.vue?vue&type=template&id=070cb27a&"
import script from "./moveEscPage.vue?vue&type=script&lang=js&"
export * from "./moveEscPage.vue?vue&type=script&lang=js&"
import style0 from "./moveEscPage.vue?vue&type=style&index=0&id=070cb27a&prod&lang=scss&"
import style1 from "./moveEscPage.vue?vue&type=style&index=1&id=070cb27a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports